export default __webpack_public_path__ + "static/media/IP_sign_in_image.4a02359c.jpeg";